<template>
    <teleport to="body">
        <div v-show="show" ref="modal" class="fixed inset-0 overflow-y-auto" :style="{'z-index': zIndex}">
            <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <transition enter-active-class="duration-300 ease-out"
                        enter-from-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="duration-200 ease-in"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
                    <div v-show="show" class="fixed inset-0 transition-all transform">
                        <div class="absolute inset-0 bg-gray-500 opacity-75 backdrop-filter backdrop-blur-md"></div>
                    </div>
                </transition>

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <transition enter-active-class="duration-300 ease-out"
                        enter-from-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
                        enter-to-class="translate-y-0 opacity-100 sm:scale-100"
                        leave-active-class="duration-200 ease-in"
                        leave-from-class="translate-y-0 opacity-100 sm:scale-100"
                        leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95">
                    <div v-show="show" class="relative inline-block px-4 pt-5 pb-4 text-left align-bottom transition-all transform sm:my-8 sm:align-middle sm:w-full sm:p-6" v-bind="$attrs">
                        <div v-show="closeable" class="absolute top-0 right-0 flex mt-6 -mr-4">
                            <button @click="close" class="text-white rounded-md hover:text-white focus:outline-none">
                                <span class="sr-only">Close panel</span>
                                <svg class="w-6 h-6" x-description="Heroicon name: outline/x" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                            </button>
                        </div>

                        <slot v-if="show"></slot>
                    </div>
                </transition>
            </div>
        </div>
    </teleport>
</template>

<script>
import { onMounted, onUnmounted, watch, ref } from "vue";

export default {
    inheritAttrs: false,
    props: {
        show: {
            type: Boolean,
            default: false
        },
        zIndex: {
            type: [String, Number],
            default: 50
        },
        closeable: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close'],
    setup(props, { emit }) {
        const modal = ref(null);

        watch(() => props.show, (state, oldState) => {
            modal.value.scrollTo({top: 0})

            if (state) {
                document.body.classList.add('overflow-hidden')
            } else {
                console.log(state, ': remove overflow hidden')
                document.body.classList.remove('overflow-hidden')
            }
        });

        const close = () => {
            if (props.closeable) {
                emit('close')
            }
        }

        const closeOnEscape = (e) => {
            if (e.key === 'Escape' && props.show && props.closeable) {
                close()
            }
        }

        onMounted(() => document.addEventListener('keydown', closeOnEscape))
        onUnmounted(() => {
            document.removeEventListener('keydown', closeOnEscape)
            document.body.classList.remove('overflow-hidden')
        })

        return {
            modal,
            close,
        }
    }
}
</script>

<style>

</style>
